class AdvertnavController {
  constructor() {
    this.name = 'advertnav';
  }
}

export default AdvertnavController;
